import { createExtension } from '@blocknote/core';
import { Extension } from '@tiptap/core';
import { TextSelection } from 'prosemirror-state';
import {
  addRowAfter,
  isInTable,
  moveCellForward,
  nextCell,
  selectionCell,
} from 'prosemirror-tables';

/**
 * BlockNote's table Enter handler moves to the cell below but returns false on
 * the last row, which lets the generic split-block shortcut run and corrupt
 * the document. Insert a row instead.
 */
export const couplespaceTableEnterExtension = createExtension({
  key: 'couplespace-table-enter',
  tiptapExtensions: [
    Extension.create({
      name: 'couplespaceTableLastRowEnter',
      priority: 55,
      addKeyboardShortcuts() {
        return {
          Enter: () =>
            this.editor.commands.command(({ state, dispatch }) => {
              if (state.selection.$head.parent.type.name !== 'tableParagraph') {
                return false;
              }
              if (!isInTable(state)) {
                return false;
              }

              const $cell = selectionCell(state);
              if (nextCell($cell, 'vert', 1)) {
                return false;
              }

              if (!dispatch) {
                return addRowAfter(state);
              }

              return addRowAfter(state, (tr) => {
                const after = state.apply(tr);
                const $next = nextCell(selectionCell(after), 'vert', 1);
                if ($next) {
                  dispatch(
                    tr
                      .setSelection(TextSelection.between($next, moveCellForward($next)))
                      .scrollIntoView(),
                  );
                  return;
                }
                dispatch(tr.scrollIntoView());
              });
            }),
        };
      },
    }),
  ],
});
